module.exports = __webpack_public_path__ + "static/media/undp.66d41827.svg";